const translateGenders = {
  MALE: 'Masculino',
  FEMALE: 'Feminino',
  TRANSGENDER_MEN: 'Homem Transgênero',
  TRANSGENDER_WOMAN: 'Mulher Transgênero',
  NON_BINARY: 'Não Binário',
  OTHERS: 'Outros',
  NOT_ANSWER: 'Prefiro não responder'
}

export default translateGenders
